import { Component, Input, OnInit } from '@angular/core';
import { APPCONFIG } from '../../config';
import { NavPreferenceUtil } from '../../_utils/nav-preference.util';

@Component({
    selector: 'my-app-sidenav',
    styles: [],
    template: require('./sidenav.component.html')
})

export class AppSidenavComponent implements OnInit {
    AppConfig;

    ngOnInit() {
        this.AppConfig = APPCONFIG;

        // EAS-249: aplica a preferência do usuário logado (caso o login tenha
        // ocorrido depois do config.ts carregar). Sem preferência salva, mantém o default.
        const stored = NavPreferenceUtil.load();
        if (stored !== null) {
            this.AppConfig.navCollapsed = stored;
        }
    }

    toggleCollapsedNav() {
        this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
        // EAS-249: estado fica lembrado entre sessões, por usuário.
        NavPreferenceUtil.save(this.AppConfig.navCollapsed);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/sidenav/sidenav.component.ts